export const REPORTS = 'md_reports_GLOBAL';